module.exports = {"sfx":[{"name":"achieve_collect","file":"/assets/sounds/files/achieve_collect.mp3","format":["mp3"]},{"name":"bg_music","file":"/assets/sounds/files/bg_music.mp3","loop":true,"type":"music","format":["mp3"]},{"name":"button_click","file":"/assets/sounds/files/button_click.mp3","format":["mp3"]},{"name":"button_rollover","file":"/assets/sounds/files/button_rollover.mp3","format":["mp3"]},{"name":"dice","file":"/assets/sounds/files/dice.mp3","format":["mp3"]},{"name":"scribble","file":"/assets/sounds/files/scribble.mp3","format":["mp3"]}]}


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/sounds/config.json
// module id = 229
// module chunks = 0